import { Space } from "antd";
import styled from "styled-components";

export const FullWidthSpace = styled(Space)`
  width: 100%;
`;
